import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { getCSSVarValue } from '../utils';

const DELAY = 300;

export default class extends Component {
  constructor(props) {
    super(props);

    this.hideTimeout = 0;

    this.state = {
      expanded: false
    };
  }
  onMouseOver = () => {
    clearTimeout(this.hideTimeout);
    const el = ReactDOM.findDOMNode(this);
    if (!this.state.expanded) {
      this.latestRect = el.getBoundingClientRect();
    }
    this.setState({ expanded: true });
  };
  onMouseOut = () => {
    this.hideTimeout = setTimeout(() => {
      this.setState({ expanded: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }, DELAY);
  };

  onSubmenuOver = () => {
    clearTimeout(this.hideTimeout);
  };

  // onSubmenuOut = () => {
  //   this.hideTimeout = setTimeout(() => {
  //     this.setState({ expanded: false });
  //   }, DELAY);
  // };

  componentDidUpdate() {
    const el = ReactDOM.findDOMNode(this);
    const submenu = el.querySelector('ul');
    if (submenu) {
      const box = submenu.getBoundingClientRect();
      if (box.bottom > window.innerHeight) {
        submenu.style.top = window.innerHeight - box.height + 'px';
      }
    }
  }

  render() {
    return (
      <li
        className="menu-item menu-item--arrow"
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
      >
        {this.props.icon && (
          <span
            className="menu-item-icon"
            style={{
              maskImage: `url(/media/icons/action-button/${this.props.icon}.svg)`,
              WebkitMaskImage: `url(/media/icons/action-button/${this.props.icon}.svg)`
            }}
          />
        )}
        {this.props.title}
        {this.props.afterElement}
        {this.state.expanded && (
          <ul
            className={
              'submenu' + (this.props.selectable ? ' submenu--selectable' : '')
            }
            style={{
              left: this.latestRect.right + 'px',
              top:
                this.latestRect.top -
                parseInt(getCSSVarValue('--menu-padding-vertical')) +
                'px'
            }}
            onMouseEnter={this.onSubmenuOver}
            // onMouseLeave={this.onSubmenuOut}
          >
            {this.props.children.map((child, index) => {
              return React.cloneElement(child, {
                key: index,
                onClick: this.props.onClick,
                onHover: this.props.onHover
              });
            })}
          </ul>
        )}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubMenu.js